export const linksToAppStoreMap: Record<string, string> = {
  ["huawei"]:
    "https://developer.huawei.com/consumer/cn/service/josp/agc/index.html#/myApp/10169556/97458334310914199",
  ["oppo"]:
    "https://open.oppomobile.com/new/mcom#/home/management/app-admin#/resource/detail?app_id=546188",
  ["tencent"]:
    "https://app.open.qq.com/p/basic/distribution/update/info?appId=100807185",
  ["vivo"]: "https://dev.vivo.com.cn/app/appService/12029",
  ["xiaomi"]:
    "https://dev.mi.com/distribute/app/2882303761517209589?namespaceValue=0&userId=352532553",
};
